export default __webpack_public_path__ + "static/media/companyIcon.048a10fe.svg";